import m1_1 from '../pdf/v2-resources/module1/Structured Lifestyle Intervention tDNA.pdf';
import m1_2 from '../pdf/v2-resources/module1/Cardiovascular Effects of Intensive Lifestyle Intervention in T2DM.pdf';
import m1_3 from '../pdf/v2-resources/module1/Localising Structured Lifestyle Intervention.pdf';
import m1_4 from '../pdf/v2-resources/module1/Is There a Role for DSFs as Meal Replacements in T2DM.pdf';

import m3_1 from '../pdf/v2-resources/module3/m3_1.pdf';
import m3_4 from '../pdf/v2-resources/module3/m3_4.pdf';
import m3_5 from '../pdf/v2-resources/module3/m3_5.pdf';
import m3_7 from '../pdf/v2-resources/module3/m3_7.pdf';
import m3_9 from '../pdf/v2-resources/module3/m3_9.pdf';
import m3_10 from '../pdf/v2-resources/module3/m3_10.pdf';

import m4_4 from '../pdf/v2-resources/module4/m4_4.pdf';
import m4_5 from '../pdf/v2-resources/module4/m4_5.pdf';
import m4_6 from '../pdf/v2-resources/module4/m4_6.pdf';
import m4_7 from '../pdf/v2-resources/module4/m4_7.pdf';

import m5_2 from '../pdf/v2-resources/module5/m5_2.pdf';
import m5_5 from '../pdf/v2-resources/module5/m5_5.pdf';
import m5_6 from '../pdf/v2-resources/module5/m5_6.pdf';
import m5_7 from '../pdf/v2-resources/module5/m5_7.pdf';
import m5_8 from '../pdf/v2-resources/module5/m5_8.pdf';

import m6_1 from '../pdf/v2-resources/module6/m6_1.pdf';
import m6_2 from '../pdf/v2-resources/module6/m6_2.pdf';
import m6_3 from '../pdf/v2-resources/module6/m6_3.pdf';
import m6_4 from '../pdf/v2-resources/module6/m6_4.pdf';
import m6_5 from '../pdf/v2-resources/module6/m6_5.pdf';
import m6_6 from '../pdf/v2-resources/module6/m6_6.pdf';

import m8_1 from '../pdf/v2-resources/module8/m8_1.pdf';
import m8_2 from '../pdf/v2-resources/module8/m8_2.pdf';
import m8_3 from '../pdf/v2-resources/module8/m8_3.pdf';
import m8_5 from '../pdf/v2-resources/module8/m8_5.pdf';
import m8_6 from '../pdf/v2-resources/module8/m8_6.pdf';
import m8_7 from '../pdf/v2-resources/module8/m8_7.pdf';
import m8_8 from '../pdf/v2-resources/module8/m8_8.pdf';
import m8_10 from '../pdf/v2-resources/module8/m8_10.pdf';

import m9_2 from '../pdf/v2-resources/module9/m9_2.pdf';

// const bonusVideos = [
//   'https://vimeo.com/1076272474',
//   'https://vimeo.com/1076272535',
//   'https://vimeo.com/1076272667',
//   'https://vimeo.com/1076272750',
//   'https://vimeo.com/1076272830',
//   'https://vimeo.com/1076272932',
// ];

export const pdfFiles = {
  pdf1: [
    {
      name: 'Structured Lifestyle Intervention Based on a Trans-Cultural Diabetes- Specific Nutrition Algorithm (tDNA) in Individuals with Type 2 Diabetes: A Randomized Controlled Trial',
      pdf: m1_1,
    },
    {
      name: 'Cardiovascular Effects of Intensive Lifestyle Intervention in Type 2 Diabetes',
      url: m1_2,
    },
    {
      name: 'Localising Structured Lifestyle Intervention for Dietary Management Success',
      pdf: m1_3,
    },
    {
      name: 'Is There a Role for Diabetes-Specific Nutrition Formulas as Meal Replacements in Type 2 Diabetes?',
      pdf: m1_4,
    },
  ],
  pdf3: [
    {
      name: 'Physical activity/Exercise and Diabetes: A position statement of the American Diabetes Association',
      pdf: m3_1,
    },
    {
      name: 'Physical Activity Readiness Questionnaire for Everyone (PAR-Q+) and electronic Physical Activity Readiness Medical Examination (ePARmed-X+)',
      url: 'https://eparmedx.com/',
    },
    {
      name: 'American College of Sports Medicine (ACSM) - Tips For Monitoring Aerobic Exercise Intensity ',
      pdf: m3_4,
    },
    {
      name: 'American College of Sports Medicine (ACSM) - Exercise Preparticipation Health Screening Recommendation',
      pdf: m3_5,
    },
    {
      name: 'GlucoseZone – Losing Weight with Diabetes',
      url: 'https://www.youtube.com/channel/UCeQAQLI6aPR2qt1cRi9hHJw',
    },
    {
      name: 'American Council on Exercise - Monitoring Exercise Intensity Using Ratings of Perceived Exertion',
      pdf: m3_7,
    },
    {
      name: 'Exercise/Physical Activity in Individuals with Type 2 Diabetes: A Consensus Statement from the American College of Sports Medicine',
      url: 'https://journals.lww.com/acsm-msse/fulltext/2022/02000/exercise_physical_activity_in_individuals_with.18.aspx',
    },
    {
      name: 'Effect of resistance training on HbA1c in adults with type 2 diabetes mellitus and the moderating effect of changes in muscular strength: a systematic review and meta-analysis',
      pdf: m3_9,
    },
    {
      name: 'Is There an Optimal Time of Day for Exercise? A Commentary on When to Exercise for People Living with Type 1 or Type 2 Diabetes',
      pdf: m3_10,
    },
    {
      name: 'Exercise Timing in Type 2 Diabetes Mellitus: A Systematic Review',
      url: 'https://journals.lww.com/acsm-msse/fulltext/2018/12000/exercise_timing_in_type_2_diabetes_mellitus__a.1.aspx#',
    },
  ],
  pdf4: [
    {
      name: 'What Is Behavior Change in Psychology? 5 Models and Theories',
      url: 'https://positivepsychology.com/behavior-change/',
    },
    {
      name: 'What is CBT? | Making Sense of Cognitive Behavioural Therapy',
      name2:
        'Notes: The video is non-diabetes related and not a 10-Minute CBT. However, it is very relevant for a basic understanding of CBT.',
      url: 'https://www.youtube.com/watch?v=9c_Bv_FBE-c',
    },
    {
      name: 'How Does CBT Help in People with Diabetes?',
      url: 'https://www.youtube.com/watch?v=4JBVyfqFk1s',
    },
    {
      name: 'Clinical Tip: Presenting the Cognitive Model to Clients',
      pdf: m4_4,
    },
    {
      name: 'Blank Cognitive - Behavioural Framework',
      pdf: m4_5,
    },
    {
      name: 'Sample Questions for Cognitive - Behavioural Framework',
      pdf: m4_6,
    },
    {
      name: 'Motivational Interviewing: Moving from WHY to HOW with Autonomy Support',
      pdf: m4_7,
    },
    {
      name: 'Motivational Interviewing for Physical Activity',
      url: 'https://www.youtube.com/watch?v=bUUSZWrr uIc',
    },
    {
      name: 'How to Set Achievable Goals (That Align with Your Values)',
      name2:
        'Notes: The article is non-diabetes related. However, it is very relevant for the topic of Setting and Reviewing Goals',
      url: 'https://www.ccl.org/articles/leading-effectively-articles/achievable-personal-goals-align-with-values/',
    },
    {
      name: 'Healthy Eating: Overcoming Barriers to Change',
      url: 'https://www.healthlinkbc.ca/healthy-eating- physical-activity/food-and-nutrition/eating- habits/healthy-eating-overcoming',
    },
    {
      name: 'The Hidden Rewards that Motivate Healthy Lifestyle Changes Long Term!',
      url: 'https://www.tyackhealth.com.au/health-news/news-archive/the-hidden-rewards-that-motivate-healthy-lifestyle-changes-long-term/',
    },
  ],
  pdf5: [
    {
      name: 'The impact of structured self-monitoring of blood glucose on glycaemic variability in non-insulin treated type 2 diabetes: The SMBG study, a 12-month randomised controlled trial',
      url: 'https://europepmc.org/article/med/31995784',
    },
    {
      name: 'Self-Monitoring Using Meters in Type 2 Diabetes',
      pdf: m5_2,
    },
    {
      name: 'American Association Of Clinical Endocrinologists And American College Of Endocrinology 2016 Outpatient Glucose Monitoring Consensus Statement',
      url: 'https://www.researchgate.net/publication/293193666_American_Association_Of_Clinical_Endocrinologists_And_American_College_Of_Endocrinology_2016_Outpatient_Glucose_Monitoring_Consensus_Statement',
    },
    {
      name: 'Structured Self-Monitoring of Blood Glucose Significantly Reduces A1C Levels in Poorly Controlled, Noninsulin-Treated Type 2 Diabetes Results from the Structured Testing Program study',
      url: 'https://doi.org/10.2337/dc10-1732',
    },
    {
      name: 'Diabetes Technology: Standards of Care in Diabetes—2025',
      pdf: m5_5,
    },
    {
      name: 'Structured self-monitoring of blood glucose is associated with more appropriate therapeutic interventions than unstructured self-monitoring: A novel analysis of data from the PRISMA trial',
      pdf: m5_6,
    },
    {
      name: 'RSSDI consensus on self-monitoring of blood glucose in types 1 and 2 diabetes mellitus in India',
      pdf: m5_7,
    },
    {
      name: 'The impact of structured self-monitoring of blood glucose on clinical, behavioral, and psychosocial outcomes among adults with non-insulin-treated type 2 diabetes: a systematic review and meta-analysis',
      pdf: m5_8,
    },
  ],
  pdf6: [
    {
      name: 'American Association Of Clinical Endocrinologists And American College Of Endocrinology 2016 Outpatient Glucose Monitoring Consensus Statement',
      pdf: m6_1,
    },
    {
      name: 'Diabetes Technology: Standards of Medical Care in Diabetes—2021',
      pdf: m6_2,
    },
    {
      name: 'Self-care coping strategies in people with diabetes (2009)',
      pdf: m6_3,
    },
    {
      name: 'Diabetes Self-management education and support in adults with Type 2 Diabetes: A consensus report of American Diabetes Association (2021)',
      pdf: m6_4,
    },
    {
      name: 'Innovative Care for Chronic Conditions: Building Blocks for Action (2002)',
      pdf: m6_5,
    },
    {
      name: 'Clinical Practical Guidelines – Management of Type 2 Diabetes Mellitus (6th Edition)',
      pdf: m6_6,
    },
  ],
  pdf7: [
    {
      name: 'Diabetes and Emotional Health - A Practical Guide for Health Professionals Supporting Adults with Type 1 and Type 2 Diabetes',
      url: 'https://professional.diabetes.org/professional-development/behavioral-mental-health/MentalHealthWorkbook',
    },
    {
      name: 'Calling All Clinicians: A Brief 5-Step Model for Exploring Diabetes Distress in Routine Diabetes Care',
      url: 'https://www.canadianjournalofdiabetes.com/article/S1499-2671(24)00063-7/abstract',
    },
    {
      name: 'Case Study 1 – Addressing Diabetes Distress',
      vimeoUrl: 'https://vimeo.com/1076272474',
    },
    {
      name: 'Case Study 2 – Addressing Fear of Hypoglycaemia',
      vimeoUrl: 'https://vimeo.com/1076272535',
    },
    {
      name: 'Case Study 3 – Addressing Fear of Insulin Intensification',
      vimeoUrl: 'https://vimeo.com/1076272667',
    },
    {
      name: 'Case Study 4 – Addressing Diabetes-related Depression',
      vimeoUrl: 'https://vimeo.com/1076272750',
    },
    {
      name: 'Case Study 5 - Addressing Diabetes-related anxiety disorder',
      vimeoUrl: 'https://vimeo.com/1076272830',
    },
    {
      name: 'Case Study 6 - Addressing Diabetes-related eating disorder',
      vimeoUrl: 'https://vimeo.com/1076272932',
    },
  ],
  pdf8: [
    {
      name: 'Treating Tobacco Use and Dependence - Quick Reference Guide for Clinicians',
      pdf: m8_1,
    },
    {
      name: 'Clinical Practice Guidelines on Treatment Of Tobacco Use And Dependence 2003',
      pdf: m8_2,
    },
    {
      name: 'Treating Tobacco Use and Dependence - Quick Reference Guide for Clinicians (2008 Update)',
      pdf: m8_3,
    },
    {
      name: 'Strengthening Primary Health Care (PHC) Systems for Treating Tobacco Dependence',
      url: 'https://www.dropbox.com/scl/fo/oaej9n7lhhc2kyt9vuzif/AKDxXYHhsHl-2a14lwVJnc8?rlkey=3j1sunrl8rt5yglu28r8ij3e3&e=1&st=uky3law8&dl=0',
    },
    {
      name: 'Effect of Sleep Disturbances on Quality of Life, Diabetes Self-Care Behavior, and Patient Reported Outcomes',
      pdf: m8_5,
    },
    {
      name: 'Stand Against Prediabetes Booklet ',
      pdf: m8_6,
    },
    {
      name: 'Relationship between sleep disturbance and self-care in adults with type 2 diabetes',
      pdf: m8_7,
    },
    {
      name: 'Sleep, circadian rhythms and health ',
      pdf: m8_8,
    },
    {
      name: 'American Diabetes Association - Standards of Medical Care in Diabetes (2021)',
      url: 'https://www.dropbox.com/scl/fo/bpcuxo54y4stefpvwhhlr/ALsoryNNQsmuHjyz8s4EL2g?rlkey=yc0eu0n6ge3pqs9yudst2leae&e=1&st=l14kc87i&dl=0',
    },
    {
      name: 'Clinical Practical Guidelines – Management of Type 2 Diabetes Mellitus (6th Edition)',
      pdf: m8_10,
    },
  ],
  pdf9: [
    {
      name: 'Travelling with Diabetes ',
      url: 'https://www.diabetes.org.uk/living-with-diabetes/life-with-diabetes/travel',
    },
    {
      name: 'Diabetes and Ramadan - Practical Guidelines 2021',
      pdf: m9_2,
    },
  ],
};
